import gql from 'graphql-tag';

const addressFields = gql`
  fragment addressFields on DTAddressData {
    firstName
    lastName
    line1
    line2
    town
    postalCode
    country {
      isocode
    }
    region {
      isocodeShort
    }
  }
`;

export const VALIDATE_POSTAL_CODE = gql`
  query validatePostalCode($postalCode: String!) {
    contactValidation {
      postalCode(postalCode: $postalCode) {
        city
        country
        state
        postalCode
        isValid: valid
      }
    }
  }
`;

export const VALIDATE_FLEET_NUMBER = gql`
query validateFleetNumber($fleetNumber: String!) {
  fleetValidation {
    fleetNumber(fleetNumber: $fleetNumber) {
      company
      companyAddress{
        line1
        postalCode
        country{
          isocode
        }
        region{
          isocode
        }
      }
      fleetNumber
      isValid: valid
    }
  }
}
`;

export const VERIFY_ADDRESS = gql`
  query verifyAddress($address: BillingAddressInput!) {
    contactValidation {
      address(address: $address) {
        suggestedAddresses {
          ...addressFields
        }
        reviewRequired
        addressData {
          ...addressFields
        }
      }
    }
  }
  ${addressFields}
`;

export const GET_ZIP_CODE_WEATHER_DATA = gql`
  query weatherDetails($zipCode: String) {
    recommendationQueries {
      weatherDetails(zipCode: $zipCode) {
        city
        state
        winterDaysPerYear
        precipitationDaysPerYear
      }
    }
  }
`;
